<template>
	<div class="container-fastmove">
		<p class="typo-h5 mt-3">
			Fast move products
		</p>
		<BaseLoading v-if="isLoading" />
		<template v-else>
			<div class="container-fastmove-tabs">
				<CRow>
					<CCol xl="9" class="d-flex align-items-center">
						<CButton
							:class="['btn-custom', {
								active: activeTabIndex === 0
							}]"
							@click="handleClickTab($event, 0)"
						>
							Top 5
						</CButton>
						<CButton
							:class="['btn-custom', {
								active: activeTabIndex === 1
							}]"
							@click="handleClickTab($event, 1)"
						>
							Top 10
						</CButton>
					</CCol>
					<CCol xl="3" class="d-flex justify-content-end align-items-center">
						<span>
							Filter:
						</span>
						<BaseDropDown
							v-model="date"
							:options="dateOptions"
							label="name"
							track-by="value"
							class="mb-0 ml-2"
							@input="hanndleDateChange"
						/>
					</CCol>
				</CRow>
			</div>
			<div class="container-fastmove-content">
				<BaseTable
					:fields="FASTMOVE_TABLE_FIELDS"
					:items="filterSkus"
					:hide-columns="['id']"
					fixed
					class="table-custom"
				>
					<template #no-items-view>
						<div class="empty-table-element">
							<p class="subtitle">
								{{ $t('message.not_found_data') }}
							</p>
						</div>
					</template>
				</BaseTable>
			</div>
		</template>
	</div>
</template>

<script>
import { numberFormat } from '../helpers/utils';
import { FASTMOVE_TABLE_FIELDS, FAST_MOVE_FILTER_OPTIONS } from '../enums/dashboard';

export default {
	name: 'DashboardFastmove',

	props: {
		isLoading: {
			type: Boolean,
			default: false,
		},
		skus: {
			type: Array,
			default: () => [],
		},
		activeTab: {
			type: Number,
			default: 0,
		},
	},

	data() {
		return {
			FASTMOVE_TABLE_FIELDS,
			date: FAST_MOVE_FILTER_OPTIONS[0],
			dateOptions: FAST_MOVE_FILTER_OPTIONS,
			activeTabIndex: 0,
		};
	},

	computed: {
		filterSkus() {
			const limit = this.activeTabIndex === 0 ? 5 : 10;
			const items = this.skus.slice(0, limit).map((item, index) => (
				{
					no: index + 1,
					...item,
					qty: numberFormat(item.qty),
				}
			));
			return items;
		},
	},

	watch: {
		activeTabIndex() {
			this.$emit('update:activeTab', this.activeTabIndex);
			this.$emit('onTabChange', this.activeTabIndex);
		},
		activeTab() {
			this.activeTabIndex = this.activeTab;
		},
	},

	created() {
		this.activeTabIndex = this.activeTab;
	},

	methods: {
		handleClickTab(event, tabIndex) {
			this.activeTabIndex = tabIndex;
		},
		hanndleDateChange(item = {}) {
			const value = (item && item.value) || null;
			this.$emit('onFilterChange', {
				date: value,
			});
		},
	},
};
</script>

<style lang="scss" scoped>
.container-fastmove {
	width: 100%;
	padding: rem(16);
	display: flex;
	flex-direction: column;
	background-color: $color-white;
	border-radius: 4px;
	box-shadow: $showdow-section;

	&-content {
		border: solid 1px $color-gray-300;
		margin-top: rem(24);
		margin-bottom: rem(30);
		border-radius: 4px;
	}
}

::v-deep .table-custom {
	margin: 0;

	td {
		&:first-child {
			width: rem(75);
		}

		&:last-child {
			width: rem(120);
		}
	}

	.empty-table-element {
		margin: 0;
	}
}

::v-deep .table-hover tbody tr:hover {
	background: none;
}

.btn-custom {
	height: rem(28);
	margin-right: rem(8);
	color: $color-black-45;

	&.active {
		background-color: $color-black;
		color: $color-white;
	}
}
</style>
